/* ==========================================================================
   Collection Product Slider — oddit-section-collection-product-slider
   Handles carousel scroll-snap sync with progress bar and optional autoplay
   ========================================================================== */
(function () {
  var SECTION_SELECTOR = '.oddit-section-collection-product-slider';
  var sectionState = new Map();

  function initSection(section) {
    var track = section.querySelector('.oddit-section-collection-product-slider__track');
    var progressIndicator = section.querySelector('.oddit-section-collection-product-slider__progress-indicator');

    if (!track || !progressIndicator) return;

    var state = {
      track: track,
      progressIndicator: progressIndicator,
      autoplayTimer: null
    };
    sectionState.set(section, state);

    function updateProgress() {
      var scrollLeft = track.scrollLeft;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        progressIndicator.style.width = '100%';
        return;
      }
      var progress = scrollLeft / maxScroll;
      var percentage = 30 + progress * 70;
      progressIndicator.style.width = percentage + '%';
    }

    track.addEventListener('scroll', updateProgress, { passive: true });
    state.handleScroll = updateProgress;

    // Initial update
    updateProgress();

    // ----------------------------------------------------------------------
    // Mouse interactions (drag, wheel, progress scrub)
    // Native horizontal scroll only reaches trackpad / touch users; the
    // handlers below let mouse users (no horizontal wheel) scroll too.
    // ----------------------------------------------------------------------
    function isScrollable() {
      return track.scrollWidth - track.clientWidth > 1;
    }

    // Temporarily disable scroll-snap while actively scrolling so manual
    // drag / wheel feels smooth, then let it snap to the nearest card.
    var snapResumeTimer = null;
    function suspendSnap() {
      track.classList.add('is-scrolling');
      if (snapResumeTimer) clearTimeout(snapResumeTimer);
    }
    function scheduleSnapResume() {
      if (snapResumeTimer) clearTimeout(snapResumeTimer);
      snapResumeTimer = setTimeout(function () {
        track.classList.remove('is-scrolling');
      }, 120);
    }

    // ---- Drag to scroll (mouse only) ----
    var isDragging = false;
    var dragMoved = false;
    var dragStartX = 0;
    var dragStartScroll = 0;

    function onPointerDown(e) {
      // Mouse only — leave touch/pen to native scrolling
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;
      if (!isScrollable()) return;
      isDragging = true;
      dragMoved = false;
      dragStartX = e.clientX;
      dragStartScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      suspendSnap();
    }

    function onPointerMove(e) {
      if (!isDragging) return;
      var dx = e.clientX - dragStartX;
      if (Math.abs(dx) > 3) dragMoved = true;
      track.scrollLeft = dragStartScroll - dx;
      if (dragMoved && e.cancelable) e.preventDefault();
    }

    function onPointerUp() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      scheduleSnapResume();
    }

    // Swallow the click that fires after a drag so it doesn't open the card
    function onClickCapture(e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }

    // Stop native image/link ghost-dragging from hijacking the gesture
    function onDragStart(e) {
      e.preventDefault();
    }

    track.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove, { passive: false });
    window.addEventListener('pointerup', onPointerUp);
    track.addEventListener('click', onClickCapture, true);
    track.addEventListener('dragstart', onDragStart);

    // ---- Wheel to horizontal scroll ----
    function onWheel(e) {
      if (!isScrollable()) return;
      // If the gesture is already horizontal (trackpad), let it pass through
      if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
      var delta = e.deltaY;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 0;
      var atEnd = track.scrollLeft >= maxScroll - 1;
      // At an edge, release the wheel so the page can scroll normally
      if ((delta < 0 && atStart) || (delta > 0 && atEnd)) return;
      suspendSnap();
      track.scrollLeft += delta;
      scheduleSnapResume();
      e.preventDefault();
    }
    track.addEventListener('wheel', onWheel, { passive: false });

    // ---- Progress bar scrubbing ----
    var progressContainer = section.querySelector('.oddit-section-collection-product-slider__progress-container');
    var isScrubbing = false;

    function scrubTo(clientX) {
      if (!progressContainer || !isScrollable()) return;
      var rect = progressContainer.getBoundingClientRect();
      if (rect.width <= 0) return;
      var ratio = (clientX - rect.left) / rect.width;
      ratio = Math.max(0, Math.min(1, ratio));
      suspendSnap();
      track.scrollLeft = ratio * (track.scrollWidth - track.clientWidth);
      scheduleSnapResume();
    }

    function onProgressDown(e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;
      isScrubbing = true;
      scrubTo(e.clientX);
      e.preventDefault();
    }
    function onProgressMove(e) {
      if (!isScrubbing) return;
      scrubTo(e.clientX);
    }
    function onProgressUp() {
      isScrubbing = false;
    }

    if (progressContainer) {
      progressContainer.addEventListener('pointerdown', onProgressDown);
      window.addEventListener('pointermove', onProgressMove, { passive: true });
      window.addEventListener('pointerup', onProgressUp);
    }

    // Save references for teardown
    state.onPointerMove = onPointerMove;
    state.onPointerUp = onPointerUp;
    state.onProgressMove = onProgressMove;
    state.onProgressUp = onProgressUp;
    state.progressContainer = progressContainer;

    // Re-check on resize
    var ro = new ResizeObserver(function () {
      updateProgress();
    });
    ro.observe(track);
    state.resizeObserver = ro;

    // Autoplay
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(section.getAttribute('data-autoplay-speed'), 10) || 5;

    if (autoplay) {
      function advanceSlide() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll <= 0) return;

        var cards = track.querySelectorAll('.oddit-section-collection-product-slider__card');
        if (!cards.length) return;

        var cardWidth = cards[0].offsetWidth;
        var gap = parseInt(window.getComputedStyle(track).gap, 10) || 0;
        var step = cardWidth + gap;
        var nextScroll = track.scrollLeft + step;

        if (nextScroll >= maxScroll) {
          nextScroll = 0;
        }

        track.scrollTo({ left: nextScroll, behavior: 'smooth' });
      }

      state.autoplayTimer = setInterval(advanceSlide, autoplaySpeed * 1000);

      // Pause on hover / focus
      function pauseAutoplay() {
        if (state.autoplayTimer) {
          clearInterval(state.autoplayTimer);
          state.autoplayTimer = null;
        }
      }

      function resumeAutoplay() {
        if (!state.autoplayTimer) {
          state.autoplayTimer = setInterval(advanceSlide, autoplaySpeed * 1000);
        }
      }

      section.addEventListener('mouseenter', pauseAutoplay);
      section.addEventListener('mouseleave', resumeAutoplay);
      section.addEventListener('focusin', pauseAutoplay);
      section.addEventListener('focusout', resumeAutoplay);

      state.pauseAutoplay = pauseAutoplay;
      state.resumeAutoplay = resumeAutoplay;
    }
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;

    // Remove scroll listener
    if (state.track && state.handleScroll) {
      state.track.removeEventListener('scroll', state.handleScroll);
    }

    // Remove window-level drag / scrub listeners
    if (state.onPointerMove) {
      window.removeEventListener('pointermove', state.onPointerMove);
    }
    if (state.onPointerUp) {
      window.removeEventListener('pointerup', state.onPointerUp);
    }
    if (state.onProgressMove) {
      window.removeEventListener('pointermove', state.onProgressMove);
    }
    if (state.onProgressUp) {
      window.removeEventListener('pointerup', state.onProgressUp);
    }

    // Disconnect resize observer
    if (state.resizeObserver) {
      state.resizeObserver.disconnect();
    }

    // Clear autoplay
    if (state.autoplayTimer) {
      clearInterval(state.autoplayTimer);
    }

    // Remove hover/focus listeners
    if (state.pauseAutoplay) {
      section.removeEventListener('mouseenter', state.pauseAutoplay);
      section.removeEventListener('mouseleave', state.resumeAutoplay);
      section.removeEventListener('focusin', state.pauseAutoplay);
      section.removeEventListener('focusout', state.resumeAutoplay);
    }

    sectionState.delete(section);
  }

  // Init all sections on page
  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();